<template>
  <div>
    <div id="bom-col-selector">
      <div>
        <h3>{{ $t('bom_tool.edit.map_col.title') }}</h3>
        <div class="bom-col-selector-row">
          <Select v-for="name in getAttrs(true)" v-model="attrs[name].value" :class="`bom-col-selector${isSelected(name) ? ` col-${name}`: ' '}`" :key="name" >
            <span slot="prefix">{{ $t(`bom_tool.edit.map_col.${name}`) }}<span class="mandatory-tip">*</span>: </span>
            <Option v-for="(item, index) in bomHeaders" :value="index" :key="index" :disabled="selectedHeaders[index]">{{ item }}</Option>
          </Select>
          <Select v-for="name in getAttrs(false)" v-model="attrs[name].value" :class="`bom-col-selector${isSelected(name) ? ` col-${name}`: ' '}`" :key="name" clearable>
            <span slot="prefix">{{ $t(`bom_tool.edit.map_col.${name}`) }}: </span>
            <Option v-for="(item, index) in bomHeaders" :value="index" :key="index" :disabled="selectedHeaders[index]">{{ item }}</Option>
          </Select>
        </div>
      </div>
      <div class="text-align-right">
        <Button style="float: left" @click="handleReupload"><Icon type="md-refresh"></Icon> {{ $t('bom_tool.edit.upload.reupload') }}</Button>
        <Button style="margin-right: 5px;" @click="handleSkip">{{ $t('bom_tool.edit.upload.skip') }}</Button>
        <Button type="primary" :disabled="!allBound()" @click="handleSubmitHeaderMapping" :loading="loading">{{ $t('bom_tool.edit.upload.next') }} <Icon type="ios-arrow-forward"></Icon></Button>
        <div class="clear-float"></div>
      </div>
    </div>
    <div id="bom-mapping-table-container">
      <vxe-grid
          size="mini"
          :height="tableHeight"
          row-key
          border
          resizable
          ref="xTable"
          row-id="id"
          :columns="tableHeaders"
          :data="tableRows"
          :cell-class-name="cellClass"
          :header-cell-class-name="cellClass">
      </vxe-grid>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
// eslint-disable-next-line
import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'

Vue.use(VXETable)
Vue.prototype.$modal = VXETable.modal

export default {
  name: 'BomUploadMap',
  data () {
    return {
      loading: false,
      // Selectors' data
      attrs: {
        level: {
          value: null,
          mandatory: false,
          keywords: [
            'lv',
            '层级',
            '#',
            'level'
          ]
        },
        type: {
          value: null,
          mandatory: true,
          keywords: [
            'type',
            '类型'
          ]
        },
        line_quantity: {
          value: null,
          mandatory: true,
          keywords: [
            'qty',
            'quantity',
            '数量',
            '用量'
          ]
        },
        specification: {
          value: null,
          mandatory: true,
          keywords: [
            'spec',
            'description',
            'specification',
            '规格',
            '技术参数',
            '技术规格'
          ]
        },
        designator: {
          value: null,
          mandatory: false,
          keywords: [
            'designator',
            '位号'
          ]
        },
        preferred_status: {
          value: null,
          mandatory: false,
          keywords: [
            'preferred',
            'preferred/alternative',
            'preferred / alternative',
            'preferred_alternative',
            'preferred-alternative',
            'preferred alternative',
            'preferred',
            'alternative',
            'preferred status',
            '推荐',
            '推荐料',
            '推荐替代料',
            '替代料'
          ]
        },
        mpn: {
          value: null,
          mandatory: false,
          keywords: [
            'mpn',
            'manufacturer part number',
            'manufacturer_part_number',
            'manufacturer-part-number',
            'manufacturerpartnumber'
          ]
        },
        name: {
          value: null,
          mandatory: false,
          keywords: [
            'name',
            '名称'
          ]
        },
        chinese_name: {
          value: null,
          mandatory: false,
          keywords: [
            'name (chinese)',
            'name(chinese)',
            'chinese name',
            'chinese_name',
            'chinese-name',
            'chinesename',
            '中文名称',
            '中文名',
            '名称（中文）'
          ]
        },
        brand: {
          value: null,
          mandatory: false,
          keywords: [
            'distributor',
            'manufacturer',
            'brand',
            '品牌',
            '厂商'
          ]
        },
        case_package: {
          value: null,
          mandatory: false,
          keywords: [
            'package / case',
            'package case',
            'package_case',
            'package-case',
            'package/case',
            'case / package',
            'case package',
            'case_package',
            'case-package',
            'case/package',
            'package',
            'case',
            '封装'
          ]
        },
        unit_name: {
          value: null,
          mandatory: false,
          keywords: [
            'unit',
            '单位'
          ]
        },
        part_number: {
          value: null,
          mandatory: false,
          keywords: [
            'part number',
            'part_number',
            'part-number',
            'partnumber',
            'pn',
            'nexpcb part number',
            '料号'
          ]
        },
        notes: {
          value: null,
          mandatory: false,
          keywords: [
            'comments',
            'notes',
            'comment',
            'note',
            '备注',
            '其他'
          ]
        },
        editor_note: {
          value: null,
          mandatory: false,
          keywords: [
            'editorcomments',
            'editornotes',
            'editorcomment',
            'editornote',
            'editor-comments',
            'editor-notes',
            'editor-comment',
            'editor-note',
            'editor_comments',
            'editor_notes',
            'editor_comment',
            'editor_note',
            'editor comments',
            'editor notes',
            'editor comment',
            'editor note',
            '编辑备注'
          ]
        }
      },
      customerBomFile: null,
      bomHeaders: [],
      selectedHeaders: [],
      tableHeaders: [],
      tableRows: [],
      tableHeight: 550
    }
  },
  mounted () {
    this.customerBomFile = this.$store.state.customerBomFile.customerBomFile
    if (this.customerBomFile === null) {
      // No BOM file uploaded, return to upload view
      this.$Notice.error({
        title: this.$t('bom_tool.edit.error.empty'),
        desc: this.$t('bom_tool.edit.error.return')
      })
      this.handleReupload()
    } else {
      this.bomHeaders = this.customerBomFile.headers
      this.selectedHeaders = new Array(this.bomHeaders.length).fill(false)
      if (this.bomHeaders.length < 5) {
        // No enough columns, return to upload view
        this.$Notice.error({
          title: this.$t('bom_tool.edit.error.length'),
          desc: this.$t('bom_tool.edit.error.return')
        })
        this.handleReupload()
      } else {
        // Auto mapping
        for (let index of Object.keys(this.attrs)) {
          for (let keyword of this.attrs[index].keywords) {
            for (let i = 0; i < this.bomHeaders.length; i++) {
              if (this.bomHeaders[i].toLowerCase() === keyword) {
                this.attrs[index].value = i
                break
              }
            }
          }
        }
        // Build table head
        for (let [index, value] of this.bomHeaders.entries()) {
          this.tableHeaders.push({
            title: value,
            field: `col_${index}`,
            maxWidth: 150,
            minWidth: 120,
            showOverflow: 'tooltip'
          })
        }
        // Build table row
        for (let row of this.customerBomFile.rows) {
          let row_obj = {}
          for (let [index, value] of row.row_data.entries()) {
            row_obj[`col_${index}`] = value
          }
          this.tableRows.push(row_obj)
        }
      }
    }
    this.tableHeight = document.querySelector('.content-wrapper.ivu-layout-content').clientHeight - 55 - document.getElementById('bom-col-selector').clientHeight
    window.addEventListener('resize', () => {
      this.tableHeight = document.querySelector('.content-wrapper.ivu-layout-content').clientHeight - 55 - document.getElementById('bom-col-selector').clientHeight
    })
  },
  watch: {
    attrs: {
      handler (newValues, oldValues) {
        this.selectedHeaders = new Array(this.bomHeaders.length).fill(false)
        for (let key in newValues) {
          // Whether the selector has value
          // null: initial value, undefined or '': selector cleared
          if (typeof newValues[key] !== 'function' && typeof newValues[key].value !== 'undefined' && newValues[key].value !== null && newValues[key].value !== '') {
            // Disable selected attrs
            this.selectedHeaders[newValues[key].value] = true
          }
        }
      },
      // data is an object, set deep: true to observe it
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'updateCustomerBomFile'
    ]),
    cellClass ({ $rowIndex, column, columnIndex, $columnIndex }) {
      for (let [key, item] of Object.entries(this.attrs)) {
        if (item.value === columnIndex) {
          if (typeof item.value !== 'undefined' && item.value !== null && item.value !== '') {
            return `col-${key}`
          }
          break
        }
      }
      return ''
    },
    allBound () {
      // Whether all mandatory attrs are set
      let flag = true
      for (let key of this.getAttrs(true)) {
        if (this.attrs[key].value === null || typeof this.attrs[key].value === 'undefined' || this.attrs[key].value === '') {
          flag = false
          break
        }
      }
      return flag
    },
    isSelected (name) {
      return (typeof this.attrs[name].value !== 'undefined' && this.attrs[name].value !== null && this.attrs[name].value !== '')
    },
    handleSkip () {
      this.$router.replace({
        name: 'menu.bom.view',
        params: {
          bomId: this.$route.query.rootBomId || this.$route.params.bomId
        },
        query: {
          rootBomId: this.$route.query.rootBomId || this.$route.params.bomId
        }
      })
    },
    handleReupload () {
      this.$router.replace({
        name: 'menu.bom.upload',
        params: {
          bomId: this.$route.query.rootBomId || this.$route.params.bomId
        },
        query: {
          rootBomId: this.$route.query.rootBomId || this.$route.params.bomId
        }
      })
    },
    getAttrs (mandatory) {
      let list = []
      for (let key of Object.keys(this.attrs)) {
        if (this.attrs[key].mandatory === mandatory) {
          list.push(key)
        }
      }
      return list
    },
    getMapping () {
      let mapping = {}
      for (let key of Object.keys(this.attrs)) {
        mapping[key] = this.attrs[key].value
      }
      return mapping
    },
    async handleSubmitHeaderMapping() {
      this.loading = true
      let res = await this.updateCustomerBomFile({
        id: this.customerBomFile.id,
        header_mapping: this.getMapping()
      })
      this.$router.replace({
        name: 'menu.bom.preview',
        params: {
          fileId: res.id || this.$route.query.customerBomFileId
        }
      })
    }
  }
}
</script>

<style lang="less">
/* Mapping colors, add more color if have added more selectors */
@colors: rgb(43, 133, 228),
  rgb(255, 153, 0),
  rgb(237, 64, 20),
  rgb(218, 65, 192),
  rgb(65, 75, 218),
  rgb(25, 190, 107),
  rgb(176, 209, 55),
  rgb(116, 61, 16),
  rgb(29, 85, 76),
  rgb(19, 179, 253),
  rgb(252, 249, 68),
  rgb(125, 241, 226),
  rgb(132, 167, 175),
  rgb(124, 29, 108),
  rgb(113, 141, 37);

/* Selectors */
@attrs: level,
  type,
  line_quantity,
  specification,
  designator,
  preferred_status,
  mpn,
  name,
  chinese_name,
  brand,
  case_package,
  unit_name,
  part_number,
  notes,
  editor_note;

/* Generate mapping colors */
.color-loop(@n, @i: 1) when (@i =< @n) {
  @name: extract(@attrs, @i);
  .vxe-table th.col-@{name}, .vxe-table td.col-@{name} {
    background-color: fade(extract(@colors, @i), 15%);
    border-right: 1px solid extract(@colors, @i);
    border-left: 1px solid extract(@colors, @i);
  }
  .vxe-table th.col-@{name} {
    background: fade(extract(@colors, @i), 30%);
    border-top: 1px solid extract(@colors, @i);
  }
  .bom-col-selector.col-@{name} > div.ivu-select-selection {
    background-color: fade(extract(@colors, @i), 15%);
    border-color: extract(@colors, @i);
  }
  .color-loop(@n, (@i + 1));
}

.color-loop(length(@colors));

.bom-col-selector {
  width: 290px;
  margin-right: 10px;
  margin-bottom: 15px;
}
.mandatory-tip {
  color: red;
}
.bom-mapping {
  background-color: transparent;
  padding: 0;
}
.clear-float {
  clear: both;
}
#bom-mapping-table-container {
  width: 100%;
  margin: 18px 0;
  max-height: 200px;
}
</style>
